import React from 'react';
import PropTypes from 'prop-types';
import {
  Switch,
  FormControlLabel,
} from '@material-ui/core';

const SwitchBase = React.forwardRef(({
  label,
  field: {
    name, value,
  },
  form: {
    setFieldValue, setFieldTouched, ...form
  },
  onChangeProps,
  numberBoolean,
  ...props
}, ref) => {
  const handleChange = (event) => {
    const optionalValue = event.target.checked ? 1 : 0;
    if (onChangeProps) {
      onChangeProps(event, form);
    }
    setFieldTouched(name, true);
    if (numberBoolean) {
      setFieldValue(name, optionalValue);
    } else {
      setFieldValue(name, event.target.checked);
    }
  };
  return (
    <FormControlLabel
      control={(
        <Switch
          id={name}
          inputRef={ref}
          checked={Boolean(value)}
          value={name}
          onChange={handleChange}
          {...props}
        />
      )}
      label={label}
    />
  );
});

SwitchBase.displayName = 'SwitchBase';

SwitchBase.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number,
      PropTypes.any,
    ]),
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape(),
    touched: PropTypes.shape(),
    setFieldTouched: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  label: PropTypes.string,
  onChangeProps: PropTypes.func,
  numberBoolean: PropTypes.bool,
};

SwitchBase.defaultProps = {
  label: '',
  numberBoolean: false,
};

export default SwitchBase;
